import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <nav 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-5">
        <div className="flex items-center justify-between">
          {/* Navigation Items */}
          <div className="flex items-center gap-10">
            <button
              onClick={() => scrollToSection('how-it-works')}
              className="text-lg font-medium text-gray-900 transition-colors hover:text-[#2B5797] cursor-pointer"
            >
              How It Works
            </button>
            <button
              onClick={() => scrollToSection('what-we-do')}
              className="text-lg font-medium text-gray-900 transition-colors hover:text-[#2B5797] cursor-pointer"
            >
              What We Do
            </button>
            <button
              onClick={() => scrollToSection('why-us')}
              className="text-lg font-medium text-gray-900 transition-colors hover:text-[#2B5797] cursor-pointer"
            >
              Why Us
            </button>
          </div>

          {/* CTA Button */}
          <a
            href="#contact"
            className="px-8 py-3 bg-[#1E3A5F] text-white text-lg font-bold rounded-lg hover:bg-[#2B5797] transition-all duration-300 shadow-md hover:shadow-lg whitespace-nowrap cursor-pointer hover:scale-105"
          >
            Book a Call
          </a>
        </div>
      </div>
    </nav>
  );
}